export default __webpack_public_path__ + "static/media/checkmark.a018ef5a.svg";